var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaScenarioBarDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "9px",
    viewBox: "0 0 17 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,0,0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avanzar escenarios") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PANTALLAS-ESCAPE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pantalla-Instrucciones",
    transform: "translate(-978, -735)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(941, 727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9584749,21 C41.7212229,21 41.4667335,20.9104902 41.2798365,20.7132821 C40.9067212,20.3195821 40.9067212,19.6930134 41.2798365,19.2993134 L47.7095956,12.4965668 L41.2798365,5.71208028 C40.9067212,5.31838027 40.9067212,4.69181151 41.2798365,4.29811151 C41.6529519,3.90371333 42.2467604,3.90371333 42.6198758,4.27993027 L49.7282732,11.7804954 C49.9151702,11.9777034 50,12.2280445 50,12.496574 C50,12.7651034 49.8979396,13.0154445 49.7282732,13.2126526 L42.6198758,20.7132177 C42.4329788,20.9104257 42.1957268,21 41.9584749,21 L41.9584749,21 Z",
    id: "avanzar-escenarios",
    transform: "translate(45.5, 12.5) rotate(-90) translate(-45.5, -12.5)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaScenarioBarDown);
export default __webpack_public_path__ + "static/media/flecha-scenario-bar-down.76dc65d51660edcf8cd9bc9f3e8596da.svg";
export { ForwardRef as ReactComponent };